/* ClickaByte Theme Injector (cb-theme.js)
   (Injects header/footer partials,s ets up theme switching, background, prog bar, particles, mobile nav, reveal, back-to-top, current year, etc etc)
*/

(() => {
  const ID = 'bg';

  function addCanvas() {
    if (document.getElementById(ID)) return;

    const c = document.createElement('canvas');
    c.id = ID;
    c.setAttribute('aria-hidden', 'true');
    c.width = 3112;
    c.height = 1152;
    c.style.cssText = 'width:1556px;height:576px;z-index:-1;';

    if (document.body.firstChild) {
      document.body.insertBefore(c, document.body.firstChild);
    } else {
      document.body.appendChild(c);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addCanvas, { once: true });
  } else {
    addCanvas();
  }
})();


(() => {
  const confTag = document.currentScript;
  const CFG = Object.assign({
    headerUrl: confTag?.dataset.header || "/assets/clickabyte/partials/header.html",
    footerUrl: confTag?.dataset.footer || "/assets/clickabyte/partials/footer.html",
    logo: confTag?.dataset.logo || "/assets/logo-square.png",
    org: confTag?.dataset.org || "ClickaByte",
    tagline: confTag?.dataset.tagline || "/ Software Development",
    defaultTheme: confTag?.dataset.theme || "light",
  }, (window.ClickaByteTheme || {}));

  const root = document.documentElement;
  if (!root.hasAttribute("data-theme")) root.setAttribute("data-theme", CFG.defaultTheme);

  // Helpers
  const qs = (s, el=document) => el.querySelector(s);
  const qsa = (s, el=document) => Array.from(el.querySelectorAll(s));
    
document.addEventListener('click', (e) => {
  const a = e.target.closest('a[href*="#"]');
  if (!a) return;

  const url = new URL(a.getAttribute('href'), location.href);
  if (!url.hash || url.hash === '#') return;
  if (url.origin !== location.origin) return;

  if (url.pathname === location.pathname) {
    const target = document.querySelector(url.hash);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });

      const nav = document.querySelector('.cb-nav');
      const toggle = document.getElementById('cbMenuToggle');
      if (nav?.classList.contains('cb-open')) {
        nav.classList.remove('cb-open');
        toggle?.setAttribute('aria-expanded', 'false');
      }
    }
  }
});

    
  // Inject background layers & prog bar
  function mountBackground() {
    if (qs("#cb-progress")) return;
    const prog = document.createElement("div");
    prog.id = "cb-progress";
    prog.className = "cb-progress";
    document.body.appendChild(prog);

    const wrap = document.createElement("div");
    wrap.className = "cb-bg-wrap";
    wrap.innerHTML = `<canvas id="cb-particles"></canvas><div class="cb-gradient"></div>`;
    document.body.appendChild(wrap);

    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const pct = max > 0 ? (window.scrollY / max) * 100 : 0;
      prog.style.width = pct + "%";
    };
    document.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    // Particles oldddd
   /* (() => {
      const c = qs("#cb-particles");
      if (!c) return;
      const ctx = c.getContext("2d");
      let w, h, px, P = [];
      function resize(){
        w = c.width = window.innerWidth * (px = Math.min(window.devicePixelRatio || 1, 2));
        h = c.height = window.innerHeight * px;
        const n = Math.max(24, Math.round(90 * Math.min(1, window.innerWidth / 1200)));
        P = Array.from({length:n}, ()=>({ x:Math.random()*w, y:Math.random()*h, vx:(Math.random()-.5)*.3, vy:(Math.random()-.5)*.3, r:1+Math.random()*2 }));
      }
      function loop(){
        ctx.clearRect(0,0,w,h);
        for(const p of P){
          p.x+=p.vx; p.y+=p.vy;
          if(p.x<0||p.x>w) p.vx*=-1;
          if(p.y<0||p.y>h) p.vy*=-1;
        }
        for(let i=0;i<P.length;i++){
          for(let j=i+1;j<P.length;j++){
            const a=P[i], b=P[j], dx=a.x-b.x, dy=a.y-b.y, d=Math.hypot(dx,dy);
            if(d<120*px){
              ctx.strokeStyle=`rgba(124,108,255,${(1-d/120)/6})`;
              ctx.beginPath(); ctx.moveTo(a.x,a.y); ctx.lineTo(b.x,b.y); ctx.stroke();
            }
          }
        }
        for(const p of P){ ctx.fillStyle='rgba(255,255,255,.6)'; ctx.beginPath(); ctx.arc(p.x,p.y,p.r,0,Math.PI*2); ctx.fill(); }
        requestAnimationFrame(loop);
      }
      resize(); window.addEventListener('resize', resize, {passive:true}); loop();
    })();*/
  }
  
  function readCSSVar(name, el = document.documentElement){
  const v = getComputedStyle(el).getPropertyValue(name).trim();
  return v || null;
}

let LINK_COLOR = readCSSVar('--link') || '#cfd3ff';

function updateLinkColor(){
  const v = readCSSVar('--link') || '#cfd3ff';
  if (v && v !== LINK_COLOR) LINK_COLOR = v;
}

const themeObserver = new MutationObserver((mutations) => {
  for (const m of mutations) {
    if (m.type === 'attributes' && m.attributeName === 'data-theme') {
      updateLinkColor();
    }
  }
});
themeObserver.observe(document.documentElement, {
  attributes: true,
  attributeFilter: ['data-theme']
});

const mql = window.matchMedia('(prefers-color-scheme: dark)');
if (mql.addEventListener) mql.addEventListener('change', updateLinkColor);
else if (mql.addListener) mql.addListener(updateLinkColor); // older Safari

updateLinkColor();
window.addEventListener('load', () => {
  updateLinkColor();
  setTimeout(updateLinkColor, 0);
  setTimeout(updateLinkColor, 250);
  setTimeout(updateLinkColor, 1000);
});

    const MQS = [
        { mq: "(max-width: 480px)", count: 40 },
        { mq: "(max-width: 768px)", count: 80 },
        { mq: "(max-width: 999px)", count: 120 },
        { mq: "(min-width: 1500px)", count: 140 },
    ];

    function currentParticleCount() {
    for (const { mq, count } of MQS) {
        if (window.matchMedia(mq).matches) return count;
    }
    return 100;
    }

    let PARTICLE_COUNT = currentParticleCount();

    
    const clamp = (n, min, max) => Math.max(min, Math.min(n, max));

    const canvas = document.getElementById('bg');
    const ctx = canvas.getContext('2d');
    const DPR = Math.min(window.devicePixelRatio || 1, 2);

    let particles = [];
    const COLORS = ['#8fbfc0', '#cfd6e3', '#9cb3d6'];
    const mouse = { x: null, y: null, vx: 0, vy: 0 };
    
	const MAX_SPEED = 1 * DPR;
	const FRICTION  = 1;
	const MOUSE_RANGE = 160 * DPR;
	const MOUSE_ACCEL = 1.5;

    const INIT_SPEED_MIN = 0.25 * DPR, INIT_SPEED_MAX = 0.35 * DPR;
    
    function resizeCanvas(){
      canvas.width = Math.floor(innerWidth * DPR);
      canvas.height = Math.floor(innerHeight * DPR);
      canvas.style.width = innerWidth + 'px';
      canvas.style.height = innerHeight + 'px';
    }

    function spawnParticles(){
        particles = Array.from({ length: PARTICLE_COUNT }, () => {
        const s = INIT_SPEED_MIN + Math.random()*(INIT_SPEED_MAX - INIT_SPEED_MIN);
        const a = Math.random() * Math.PI * 2;
        return {
            x: Math.random()*canvas.width,
            y: Math.random()*canvas.height,
            vx: Math.cos(a) * s,
            vy: Math.sin(a) * s,
            r: (Math.random()*2 + 0.8) * DPR,
            c: COLORS[(Math.random()*COLORS.length)|0],
            pulse: Math.random()*Math.PI*2
        };
        });
    }

    let lastTime = performance.now();
	function tickParticles(now){
	  const dt = Math.min((now - lastTime) / 16.6667, 2);
	  lastTime = now;
	
	  ctx.clearRect(0,0,canvas.width,canvas.height);
	
	  for(const p of particles){
		if(mouse.x !== null){
		  const mx = mouse.x * DPR, my = mouse.y * DPR;
		  const dx = p.x - mx, dy = p.y - my;
		  const dist = Math.hypot(dx, dy) || 1;
		  if(dist < MOUSE_RANGE){
			const falloff = (MOUSE_RANGE - dist) / MOUSE_RANGE;
			const ax = (dx / dist) * (MOUSE_ACCEL * falloff) * dt;
			const ay = (dy / dist) * (MOUSE_ACCEL * falloff) * dt;
			p.vx += ax;
			p.vy += ay;
		  }
		}
	
		p.vx *= Math.pow(FRICTION, dt);
		p.vy *= Math.pow(FRICTION, dt);
	
		const speed = Math.hypot(p.vx, p.vy);
		if(speed > MAX_SPEED){
		  const s = MAX_SPEED / speed;
		  p.vx *= s; p.vy *= s;
		}
	
		p.x += p.vx * dt;
		p.y += p.vy * dt;
	
		if(p.x < 0) p.x = canvas.width;
		if(p.x > canvas.width) p.x = 0;
		if(p.y < 0) p.y = canvas.height;
		if(p.y > canvas.height) p.y = 0;
	
		p.pulse += 0.02 * dt;
		const r = p.r + Math.sin(p.pulse) * 0.15 * DPR;
		ctx.beginPath();
		ctx.fillStyle = p.c;
		ctx.globalAlpha = 0.75;
		ctx.arc(p.x, p.y, r, 0, Math.PI*2);
		ctx.fill();
	  }
	
	  for(let i=0;i<particles.length;i++){
		for(let j=i+1;j<particles.length;j++){
		  const a = particles[i], b = particles[j];
		  const dx = a.x-b.x, dy = a.y-b.y; const d2 = dx*dx + dy*dy;
		  const maxD = 130*DPR;
		  if(d2 < maxD*maxD){
			ctx.beginPath();
			ctx.moveTo(a.x, a.y); ctx.lineTo(b.x, b.y);
			const o = 0.08 * (1 - Math.sqrt(d2)/maxD);
			ctx.globalAlpha = o;
			ctx.strokeStyle = LINK_COLOR;
			ctx.lineWidth = DPR;
			ctx.stroke();
		  }
		}
	  }
	  ctx.globalAlpha = 1;
	
	  requestAnimationFrame(tickParticles);
	}

    const ripples = document.querySelector('.ripples');
    function makeRipple(x, y){
      const r = document.createElement('span');
      r.className = 'ripple';
      r.style.left = x + 'px'; r.style.top = y + 'px';
      ripples.appendChild(r);
      r.addEventListener('animationend', () => r.remove());
    }

    window.addEventListener('resize', () => { resizeCanvas(); spawnParticles(); });

    window.addEventListener('pointermove', (e) => {
  	  mouse.x = e.clientX; mouse.y = e.clientY;
	}, { passive: true });

    window.addEventListener('touchstart', (e) => {
      const t = e.touches[0]; if(!t) return; mouse.x = t.clientX; mouse.y = t.clientY; makeRipple(mouse.x, mouse.y);
    }, { passive: true });

  // Reveal
  function setupReveal() {
    const els = qsa(".cb-reveal");
    if (!els.length || !("IntersectionObserver" in window)) return;
    const obs = new IntersectionObserver((entries, o)=>{
      entries.forEach(e=>{
        if (e.isIntersecting) {
          e.target.classList.add("cb-show");
          o.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(el => obs.observe(el));
  }

  // Theme toggle
  function setupThemeToggle() {
    const saved = localStorage.getItem("theme");
    if (saved) root.setAttribute("data-theme", saved);
    const btn = qs("#cbThemeBtn");
    if (btn) btn.addEventListener("click", ()=>{
      const t = root.getAttribute("data-theme") === "dark" ? "light" : "dark";
      root.setAttribute("data-theme", t); localStorage.setItem("theme", t);
    });
  }

  // Mobile nav
  function setupMobileNav(scope=document) {
    const nav = qs(".cb-nav", scope);
    const toggle = qs("#cbMenuToggle", scope);
    const links = qs("#cbNavLinks", scope);
    if(!nav || !toggle || !links) return;

    const close = () => { nav.classList.remove('cb-open'); toggle.setAttribute('aria-expanded','false'); };
    toggle.addEventListener('click', () => {
      const open = !nav.classList.contains('cb-open');
      nav.classList.toggle('cb-open', open);
      toggle.setAttribute('aria-expanded', String(open));
    });
    qsa('a', links).forEach(a => a.addEventListener('click', close));
    window.addEventListener('resize', () => { if (window.innerWidth > 860) close(); });
  }

  // Footer utils
  function setupFooterBits(scope=document) {
    const y = qs("#cbYear", scope);
    if (y) y.textContent = String(new Date().getFullYear());
    const btt = qs("#cbBackToTop", scope);
    if (btt) btt.addEventListener("click", () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  function applyBrand(scope=document) {
    const logo = CFG.logo;
    const org = CFG.org;
    const tagline = CFG.tagline;

    const brandLink = qs(".cb-brand", scope);
    if (brandLink) {
      const img = qs(".cb-brand-logo", brandLink);
      if (img && logo) img.src = logo;
      const strong = qs("strong", brandLink);
      if (strong) strong.textContent = org;
      const span = brandLink.querySelector("span.cb-muted");
      if (span) span.textContent = ` ${tagline}`;
    }

    const footerLogo = qs(".cb-footer-brand img", scope);
    if (footerLogo && logo) footerLogo.src = logo;

    const footerStrong = qs(".cb-footer-brand strong", scope);
    if (footerStrong) footerStrong.textContent = org;
  }

  // Fetch & inject partials
  async function inject(targetSelector, url) {
    let mount = qs(targetSelector);
    const html = await fetch(url, { credentials: "same-origin" }).then(r => r.text()).catch(()=>null);
    if (!html) return null;

    const tmp = document.createElement("div");
    tmp.innerHTML = html.trim();

    const el = tmp.firstElementChild;
    if (!mount) {
      if (/header|nav/i.test(el.tagName)) {
        document.body.prepend(el);
      } else {
        document.body.appendChild(el);
      }
    } else {
      mount.replaceWith(el);
    }
    return el;
  }

  // Boot
  document.addEventListener("DOMContentLoaded", async () => {
    mountBackground();

    // Inject header & footer
    const headerEl = await inject("#cb-header", CFG.headerUrl);
    const footerEl = await inject("#cb-footer", CFG.footerUrl);

    setupMobileNav(document);
    setupThemeToggle();
    function waitForBG(selector, time) {
        if(document.querySelector(selector)!=null) {
          resizeCanvas();
          spawnParticles();
          lastTime = performance.now();
	      requestAnimationFrame(tickParticles);
          return;
        } else setTimeout(()=>waitForBG(selector, time), time);
    }
    
    waitForBG('#bg',300)
    setupReveal();
    if (footerEl) setupFooterBits(document);
    applyBrand(document);
  });
})();




// --- Services dropdown: touch opens, mouse navigates ---
(() => {
  // prevent double init
  if (window.__cbServicesDropdownInit_v3) return;
  window.__cbServicesDropdownInit_v3 = true;

  const SERVICES_URL = "/services";

  const isTouchLikeEnv = () =>
    window.matchMedia("(hover: none) and (pointer: coarse)").matches ||
    (navigator.maxTouchPoints && navigator.maxTouchPoints > 0);

  const closeAll = (except = null) => {
    document.querySelectorAll(".cb-dropdown.opendd").forEach((dd) => {
      if (except && dd === except) return;
      dd.classList.remove("opendd");
      dd.querySelector(".cb-dropdown-toggle")?.setAttribute("aria-expanded", "false");
    });
  };

  const attach = (dd) => {
    if (!dd || dd.__cbBound) return;
    dd.__cbBound = true;

    const toggle = dd.querySelector(".cb-dropdown-toggle");
    const menu = dd.querySelector(".cb-dropdown-menu");
    if (!toggle) return;

    let lastPointerType = "mouse";

    // track pointer type on this control
    toggle.addEventListener(
      "pointerdown",
      (e) => {
        lastPointerType = e.pointerType || "mouse";
      },
      { passive: true }
    );

    // KEY FIX: capture click on the TOGGLE so it runs BEFORE any "close menu" click handlers
    toggle.addEventListener(
      "click",
      (e) => {
        const touchLike = lastPointerType === "touch" || lastPointerType === "pen" || isTouchLikeEnv();

        if (touchLike) {
          // Touch: toggle dropdown, do not navigate
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          const isOpen = dd.classList.contains("opendd");
          if (isOpen) {
            dd.classList.remove("opendd");
            toggle.setAttribute("aria-expanded", "false");
          } else {
            closeAll(dd);
            dd.classList.add("opendd");
            toggle.setAttribute("aria-expanded", "true");
          }
          return;
        }

        // Mouse: navigate to /services
        closeAll();
        const url = toggle.getAttribute("data-href") || SERVICES_URL;
        window.location.assign(url);
      },
      true // capture is crucial
    );

    // Prevent clicks inside the dropdown menu from bubbling to "close mobile menu" handlers
    menu?.addEventListener(
      "click",
      (e) => {
        e.stopPropagation();
      },
      true
    );
  };

  // init now + handle injected header later
  const scan = () => document.querySelectorAll(".cb-dropdown").forEach(attach);
  scan();

  const mo = new MutationObserver(scan);
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Close dropdown on outside click
  document.addEventListener(
    "click",
    (e) => {
      if (!e.target.closest(".cb-dropdown")) closeAll();
    },
    true
  );

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeAll();
  });
})();

